export default {
    namespaced:true,
    state: {
        visible: false,
    },

    mutations: {
      start (state) {
        state.visible = true
      },

      stop (state) {
        state.visible = false
      }
    }

}


// WEBPACK FOOTER //
// ./src/store/modules/loader.js